<template>
    <l-control position="topleft">
        <b-button @click="showModal" 
            class="shadow-lg" 
            variant="dark"
        >
            <img src="../assets/interface/hint.svg" 
                class="mx-n1" 
                style="height:1.5em;filter:invert(90%)" 
            />
        </b-button>
        <b-modal :visible="$route.query.new ? true : false" @hidden="$emit('hidden')" ref="modal" ok-only centered :title="title"
            :header-bg-variant="darkmode ? 'dark' : ''"
            :header-text-variant="darkmode ? 'light' : ''"
            :body-bg-variant="darkmode ? 'dark' : ''" 
            :body-text-variant="darkmode ? 'light' : ''"
            :footer-bg-variant="darkmode ? 'dark' : ''"
            :footer-text-variant="darkmode ? 'light' : ''">
            <div class="d-flex flex-column">
                <div class="d-flex my-1">
                    <span>
                        Auf der Karte findest du Benutzer, die eine Mitfahrgelegenheit zur 
                        Schule suchen oder anbieten und kannst ihnen mit einem Knopfdruck eine Nachricht schicken.
                    </span>
                </div>

                <div class="d-flex my-1">
                    <img src="../assets/map/school.svg" class="align-self-center mr-3" style="height:2em" />
                    <span>
                        An diesem Ort befindet sich das Berufliche Schulzentrum Wiesau.
                    </span>
                </div>

                <div class="d-flex my-1">
                    <img src="../assets/map/home.svg" class="align-self-center mr-3" style="height:2em" />
                    <span>
                        Das ist dein öffentlicher Marker. Verschiebe ihn auf der Karte
                        dort hin, wo du deine Mitfahrer am liebsten mitnehmen möchtest,
                        oder von wo dich deine Fahrer am besten abholen können.
                    </span>
                </div>

                <div class="d-flex my-1">
                    <img src="../assets/map/user.svg" class="align-self-center mr-3" style="height:2em" />
                    <span>
                        Suchst du nach Mitfahrern schau nach diesen Markern,
                        die zwischen dir und der Schule liegen.
                    </span>
                </div>

                <div class="d-flex my-1">
                    <img src="../assets/map/car.svg" class="align-self-center mr-3" style="height:2em" />
                    <span>
                        Suchst du nach Fahrern, schau am besten nach solchen Markern, 
                        die von der Schule aus betrachtet hinter deinem Wohnort liegen.
                    </span>
                </div>
            </div>
        </b-modal>
    </l-control>
</template>

<script>
import { LControl } from 'vue2-leaflet'
import { mapGetters } from 'vuex'
export default {
    name: "UebersichtControlHint",
    components: {
        LControl
    },
    computed:{
        ...mapGetters(['darkmode']),
        title: function(){
            return this.$route.query.new ? 'Wilkommen in der BSZW-Mitfahrzentrale' : 'Hilfe zur Benutzung'
        }
    },
    methods:{
        showModal(){
            this.$refs.modal.show()
        }
    }
}
</script>